import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCyxb0_eKpyrdxpG1_O9MO-PRqFgFC88Bc",
  authDomain: "sheetshed-b9586.firebaseapp.com",
  projectId: "sheetshed-b9586",
  storageBucket: "sheetshed-b9586.firebasestorage.app",
  messagingSenderId: "1028028154364",
  appId: "1:1028028154364:web:82f4438c88246828933279",
  measurementId: "G-5WDCYVKSPE"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Set persistent login - stays logged in even after browser close
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Auth persistence error:', error);
});

export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
export default app;

